import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getServices = async (salonId: string | undefined) => {
  const { data, error } = await supabase
    .from('services')
    .select('*')
    .eq('salon', salonId)

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useGetServicesBySalonId(salonId: string | undefined) {
  return useQuery({
    queryKey: ['salonServices', salonId],
    queryFn: () => getServices(salonId),
    staleTime: 0,
    enabled: !!salonId
  })
} 